const leadAdapter = l => ({
  id: l.id,
  ...l.attributes,
  relationships: {
    ...l.relationships,
  },
});

export default leadAdapter;
